module.exports = __webpack_public_path__ + "img/schema_oms_3b.ce4a9295.svg";